export default __webpack_public_path__ + "static/media/icon-brand-card-bank.c136d3c0.svg";